import { render } from "./HeaderLogo.vue?vue&type=template&id=36b68523&scoped=true&ts=true"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts"

import "./HeaderLogo.vue?vue&type=style&index=0&id=36b68523&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b68523"]])

export default __exports__